import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, MutationIntentProjectDeleteArgs } from "types/generated";

export const DELETE_INTENT_PROJECT: TypedDocumentNode<
  { intentProjectDelete: IntentProject | null },
  Omit<MutationIntentProjectDeleteArgs, "keepResources">
> = gql`
  mutation DeleteIntentProject($id: ID!) {
    intentProjectDelete(id: $id) {
      id
      name
    }
  }
`;
